import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Reveal from '../components/Reveal';
import ClayIcon from '../components/site/ClayIcon';
import { STATS } from '../siteConfig';
import './About.css';

const VALUES = [
  { key: 'reliability', icon: 'clock' },
  { key: 'safety', icon: 'shield' },
  { key: 'quality', icon: 'diamond' },
  { key: 'customer', icon: 'handshake' },
];

function About() {
  const { t, i18n } = useTranslation();
  const values = t('about.ourValues', { returnObjects: true });
  const reasons = t('about.whyChoose.reasons', { returnObjects: true });

  return (
    <div className="about-page">
      {/* Header */}
      <section className="about-header hero-band hero-band-photo" style={{ '--card-photo': 'url(/images/taxiready2go-photos/fleet-three-taxis-banner.jpg)' }}>
        <div className="container">
          <h1>{t('about.header.title')}</h1>
          <p>{t('about.header.subtitle')}</p>
        </div>
      </section>

      {/* Our Story */}
      <section className="our-story">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>{t('about.ourStory.title')}</h2>
              <p>{t('about.ourStory.p1')}</p>
              <p>{t('about.ourStory.p2')}</p>
            </div>
            <div className="story-image">
              <img src="/images/fleet-2.jpg" alt="TaxiReady2Go vehicle at hotel pickup" />
            </div>
          </div>
        </div>
      </section>

      {/* Our Fleet */}
      <section className="our-fleet">
        <div className="container">
          <h2 className="section-heading">{t('about.ourFleet.title')}</h2>
          <div className="fleet-gallery">
            <Reveal className="fleet-item">
              <img src="/images/fleet-1.jpg" alt="TaxiReady2Go cars waiting for pickup" />
              <div className="fleet-caption">Ready for pickup</div>
            </Reveal>
            <Reveal className="fleet-item" delay={60}>
              <img src="/images/fleet-3.jpg" alt="TaxiReady2Go taxis at hotel entrance" />
              <div className="fleet-caption">At the hotel</div>
            </Reveal>
            <Reveal className="fleet-item" delay={120}>
              <img src="/images/fleet-4.jpg" alt="TaxiReady2Go fleet lined up at hotel entrance" />
              <div className="fleet-caption">Our fleet</div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="our-values">
        <div className="container">
          <h2 className="section-heading">{values.title}</h2>
          <div className="values-grid">
            {VALUES.map(({ key, icon }, index) => (
              <Reveal key={key} delay={index * 60} className="value-card card-lift">
                <ClayIcon name={icon} size={72} className="value-icon" />
                <h3>{values[key].title}</h3>
                <p>{values[key].desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose">
        <div className="container">
          <h2 className="section-heading">{t('about.whyChoose.title')}</h2>
          <div className="reasons-list-wrap">
            <div className="reasons-list">
              {reasons.map((reason, index) => (
                <Reveal key={index} className="reason" delay={index * 60}>
                  <div className="step-indicator reason-number">{String(index + 1).padStart(2, '0')}</div>
                  <div className="reason-content">
                    <h3>{reason.title}</h3>
                    <p>{reason.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Team Stats */}
      <section className="team-stats">
        <div className="container">
          <h2 className="section-heading">{t('about.teamStats.title')}</h2>
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">{STATS.customers.toLocaleString(i18n.language)}+</div>
              <div className="stat-label">{t('home.stats.customers')}</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{STATS.drivers}+</div>
              <div className="stat-label">{t('home.stats.drivers')}</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{STATS.years}+</div>
              <div className="stat-label">{t('site.stats.years')}</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">{t('home.stats.available')}</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta hero-band hero-band-photo" style={{ '--card-photo': 'url(/images/taxiready2go-photos/two-taxis-hotel-banner.jpg)' }}>
        <div className="container">
          <h2>{t('about.cta.title')}</h2>
          <p>{t('about.cta.subtitle')}</p>
          <Link to="/#book" className="btn btn-primary btn-large">{t('about.cta.bookButton')}</Link>
        </div>
      </section>
    </div>
  );
}

export default About;
